/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

*,
:host {
  box-sizing: border-box;
  font-size: 1rem;
  font-family: inherit;
}

:host button,
:host input,
:host optgroup,
:host select,
:host textarea {
  font-family: inherit;
}

:host {
  display: inline-block;
  vertical-align: middle;
  line-height: 1.4285714286rem;
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
}
:host label {
  font-weight: 600;
}

:host([hidden]) {
  display: none;
}`;
export { style };
